<template>
  <div class="container my-1">
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">

      <div class="postlist  mt-1 font-be-vietnam">
        <div class="filter">
          <div class="row breadcrumb_category_child" style="border-bottom: 1px solid #E8E8E8">
            <div class="col-12 col-md-7">
              <ul>
                <li v-if="currentSlug === 'BBT'">
                  <router-link :to="{ name: 'home-part', params: 'BBT' }">
                    Ban Biên tập
                  </router-link>
                </li>
                <li v-if="currentSlug === 'TT-TN'">
                  <router-link :to="{ name: 'home-part', params: 'TT-TN' }">
                    Thường trú trong nước
                  </router-link>
                </li>
                <li v-if="['TT-NN', 'TTNN'].includes(currentSlug)">
                  <router-link :to="{ name: 'home-part', params: 'TT-NN' }">
                    Thường trú nước ngoài
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="col-12 col-md-5 mt-xs-2 pr-1">
              <div class="d-flex flex-row justify-content-end algin-items-center">
                <div class="total" style="white-space: nowrap;"> Chế độ hiển thị: </div>
                <b-button v-b-tooltip.hover variant="white" title="Dạng danh sách" class=""
                  :class="showMode === 'list' ? 'show_list_view' : ''" @click="switchMode('list')">
                  <feather-icon icon="ListIcon" /></b-button>
                <b-button v-b-tooltip.hover class="mt-0 p-0" title="Dạng lưới"
                  :class="showMode === 'grid' ? 'show_list_view' : ''" variant="White" @click="switchMode('grid')">
                  <feather-icon icon="GridIcon" /></b-button>
                <div class="total pr-5px pl-5px">
                  |
                </div>
                <b-button variant="blue" @click="refreshData(currentSlug)">
                  <feather-icon icon="RepeatIcon" /> Làm mới</b-button>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-12 col-md-4">
              <b-form-group label="Tiêu đề" class="font-weight-bolder mb-0">
                <b-form-input v-model="localSearchQuery" placeholder="Tiêu đề" @keyup.enter="updateSearchQuery" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-2 mt-xs-1">
              <b-form-group label="Thể loại" class="font-weight-bolder mb-0">
                <v-select v-model="article_type" :options="dataArticleType" label="name" :reduce="(val) => val.id"
                  placeholder="--Chọn--" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-2">
              <b-form-group label="Phòng ban" class="font-weight-bolder mb-0">
                <v-select v-model="department_id" :options="parentDepart" label="name" :reduce="(val) => val.id"
                  placeholder="--Chọn--" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3 mt-xs-1">
              <b-form-group label="Ngày đăng" class="font-weight-bolder mb-0">
                <date-picker ref="datetime" v-model="loadDateRange" type="datetime" range :shortcuts="shortcuts"
                  :show-time-panel="false" format="DD/MM/YYYY" value-type="format"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-1 p-0">
              <b-button variant="gradient-danger" class="d-flex" @click="updateSearchQuery"><feather-icon
                  icon="SearchIcon" />&nbsp;&nbsp;Tìm kiếm </b-button>
            </div>
          </div>
        </div>
        <div class="card shadow-sm " style="border: none;">
          <div class="card-body p-1">
            <!-- Pagination -->
            <b-row class="mb-1">
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-dark font-weight-600">{{ $t('show_to_entries', {
                  from: dataMeta.from, to: dataMeta.to,
                  of: dataMeta.of
                }) }}</span>
              </b-col>
              <b-col v-if="total" cols="12" sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" :limit="8" first-number
                  last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>

            <!-- LIST VIEW -->
            <div class="home_post_list" :class="showMode === 'list' ? 'show' : 'hide'">
              <div v-for="(item, index) in itemsData" :key="index" class="card-body p-1 mb-5px d-flex list_item"
                style="border: 1px solid #E8E8E8; border-radius: 6px;">
                <div class="w-15 column_time">
                  <div class="d-flex align-items-center">
                    <span class="iconClock" /> <span
                      class="font-size14-be-vietnam  text-dark text-center font-weight-600">{{ item.published_at }}</span>
                  </div>
                  <div class="pt-5px">
                    <span class="text-dark-3 font-size14-be-vietnam"> <span class="iconFolder" /></span> <span
                      class="text-dark font-size14-be-vietnam font-weight-600">{{ item.category ?
                        capFirst(item.category.name) : '' }}</span>
                  </div>
                </div>
                <div class="w-60 column_content">
                  <div class="d-flex">
                    <div class="div_img">
                      <router-link :to="{ name: 'home-view', params: { id: item.id, slug: item.slug } }"
                        class="link a_img" event @click.native.prevent="openPreviewModal(item)">
                        <b-img thumbnail :src="item.image" class="thumbnail_img p-0" />
                      </router-link>
                    </div>
                    <div class="pl-1 div_title">
                      <router-link :to="{ name: 'home-view', params: { id: item.id, slug: item.slug } }" class="link"
                        event @click.native.prevent="openPreviewModal(item)">
                        <div class=" text-wrap">
                          <span :class="renderClassTitleView(item)">{{ item.title }}
                            <span v-if="item.hot" class="iconHotGif" />
                            <span v-if="item.is_get" class="iconNewsRead" />
                          </span>
                        </div>
                      </router-link>
                      <div class="news-icon d-flex flex-row pt-5px">
                        <span v-for=" (type, key) in item.content_type" :key="key"
                          class="d-flex justify-content-between pr-5px">
                          <span v-if="type === 'audio'" class="iconAudioBlue" />
                          <span v-if="type === 'photo'" class="iconPhotoBlue" />
                          <span v-if="type === 'video'" class="iconVideoBlue" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-25 column_author">
                  <div class="d-flex">
                    <div class="text-dark font-size14-be-vietnam w-30">
                      <span class="text-dark font-size14-be-vietnam font-weight-600">Tác giả: </span>
                    </div>
                    <div class="w-70 d-flex">
                      <span class="text-primary font-weight-700 font-size14-be-vietnam">{{ item.author ? item.author.unit
                        : '' }} <span class="text-dark-3 font-size14-be-vietnam font-weigh-500">{{
    item.author ? '(' + (item.author.alias ? item.author.alias : item.author.username) + ')' : ''
  }}</span></span>
                    </div>
                  </div>
                  <div class="d-flex pt-5px">
                    <div class="text-dark font-size14-be-vietnam w-30 font-weight-600 mt-5px">
                      Ban lấy tin:
                    </div>
                    <div class="w-70 ">
                      <div class="d-flex flex-wrap">
                        <div v-for="(childs, k ) in (item.part_unit)" :key="k" class="parent mr-5px mt-5px mb-5px">
                          <span class="item_part font-weight-600  font-be-vietnam">{{ k }} {{ childs.length > 0 ? '(' +
                            childs.length + ')' : '' }} </span>
                          <div v-if="childs.length > 0" class="item_child mt-5px p-1">
                            <span v-for="(child, index1) in (childs)" :key="index1"
                              class="item_part_child mr-5px flex-wrap font-be-vietnam"> {{ child.department_code }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- GRID VIEW -->
            <div class=" row d-flex" :class="showMode === 'grid' ? 'show' : 'hide'">
              <div v-for="(item, index) in itemsData " :key="index" class="col-5-item mb-1 pl-5px pr-5px">
                <router-link :to="{ name: 'home-view', params: { id: item.id, slug: item.slug } }" class="div_thumbnail"
                  event @click.native.prevent="openPreviewModal(item)">
                  <b-img thumbnail :src="item.image" />
                </router-link>
                <div class="padding-category font-be-vietnam font-weight-500 font-size14-be-vietnam"
                  style="color: #086BB5;">{{ item.category ? capFirst(item.category.name) : '' }}</div>
                <div class="">
                  <h3 class="news-title">
                    <router-link :to="{ name: 'home-view', params: { id: item.id, slug: item.slug } }" class="link d-flex"
                      event @click.native.prevent="openPreviewModal(item)">
                      <span class="trunc trunc-2" :class="renderClassTitleView(item)">{{ item.title }}
                        <span v-if="item.hot" class="iconHotGif" />
                        <span v-if="item.is_get" class="iconNewsRead" />
                      </span>
                    </router-link>
                  </h3>

                </div>
                <div class="news-icon col-12 p-0">
                  <div class="news-icon d-flex  ">
                    <div class="col-md-4 col-3 d-flex p-0">
                      <span v-for=" (type, key) in item.content_type" :key="key">
                        <span v-if="type === 'audio'" class="iconAudioBlue" />
                        <span v-if="type === 'photo'" class="iconPhotoBlue" />
                        <span v-if="type === 'video'" class="iconVideoBlue" />
                      </span>
                    </div>
                    <div class="col-md-8 col-9 d-flex p-0 justify-content-end">
                      <span> {{ item.format_published_at }} </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Pagination -->
            <b-row class="mt-2">
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-dark font-weight-600">{{ $t('show_to_entries', {
                  from: dataMeta.from, to: dataMeta.to,
                  of: dataMeta.of
                }) }}</span>
              </b-col>
              <b-col v-if="total" cols="12" sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" :limit="8" first-number
                  last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-overlay>
    <!-- MODAL PREVIEW -->
    <ViewPopup :show-preview="showPreview" :article-id="articleId" @close="onPreviewHidden"
      @on-view-article="onViewArticle" @on-read-article="onReadArticle" />
  </div>
</template>
<script>
import {
  BOverlay,
  BRow,
  BCol,
  BButton,
  BPagination,
  BImg,
  BFormInput,
  BFormGroup,
  VBTooltip,
} from 'bootstrap-vue';

import {
  ref, watch, onMounted, onBeforeUnmount,
} from '@vue/composition-api';
import vSelect from 'vue-select'
import moment from 'moment';
import Ripple from 'vue-ripple-directive';
import DatePicker from 'vue2-datepicker';
import { showToast, useRouter } from '@/@core/utils/utils';
import store from '@/store'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
import useCategory from './useCategory';

export default {
  components: {
    BOverlay,
    BRow,
    BCol,
    BButton,
    BPagination,
    BImg,
    BFormInput,
    BFormGroup,
    vSelect,
    DatePicker,
    ViewPopup: () => import(/* webpackPrefetch: true */ './ViewPopup.vue'),

  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      dataParent: [],
      moment,
    }
  },
  computed: {
    // updateListData: {
    //   set() { },
    //   get() { return this.$store.state.article.article_list_corrected },
    // },
  },
  watch: {
    // updateListData() {
    //   this.fetchAll()
    // },
    loadDateRange(newDate, oldDate) {
      this.start_date = (newDate[0]) ? newDate[0] : ''
      this.end_date = (newDate[1]) ? newDate[1] : ''
      this.$refs.datetime.closePopup()
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const parentDepart = ref([])

    const {
      loading,
      perPage,
      total,
      from,
      to,
      dataMeta,
      allowResetCurrentPage,
      allowRefetchPaginate,
      currentPage,
      searchQuery,
      localSearchQuery,
      itemsData,
      dataArticleType,
      department_id,
      start_date,
      bookDate,
      end_date,
      article_type,
      refListTable,
      dataDepartment,
      currentSlug,
      category_id,
      loadDateRange,
      dataCategory,
      category,
      resultData,
      dataPhongBan,
      department_unit,
      showMode,
      classShowMode,
      Imgsize,
      tableColumns,
      shortcuts,
      fetchAllArticleType,
      fetchAllDepartment,
      onWindowScroll,
      switchMode,
      capFirst,
      compactShowPart,
      extraShowPart,
      lengthPart,
      renderClassTitleView,
      articleId,
      articleData,
      showPreview,
      onViewArticle,
      onReadArticle,
    } = useCategory(context);

    // overide old setup
    perPage.value = 50

    fetchAllDepartment()
    fetchAllArticleType()

    if (route.value.params.slug) {
      currentSlug.value = route.value.params.slug
    }
    if (route.value.params.id) {
      category_id.value = route.value.params.id
    }

    const openPreviewModal = (item) => {
      articleId.value = item.id
      articleData.value = item
      showPreview.value = true
    }
    const onPreviewHidden = () => {
      showPreview.value = false
      articleData.value = null
    }

    const fetchAll = (isPaginate = 0) => {
      if (!currentSlug.value) {
        return;
      }
      if (!isPaginate) {
        loading.value = true;
      }
      if (allowRefetchPaginate.value) {
        total.value = 0;
      }
      store.dispatch('home/fetchDataOfPart', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        slug: currentSlug.value,
        department_id: department_id.value,
        start_date: start_date.value,
        end_date: end_date.value,
        article_type: article_type.value,
        book_date: bookDate.value,
        isPaginate,
      })
        .then(response => {
          loading.value = false
          const result = response.data;
          if (result.code === 200) {
            if (isPaginate) {
              from.value = result.data.from
              total.value = result.data.total
            } else {
              setTimeout(() => {
                if (allowRefetchPaginate.value) {
                  allowRefetchPaginate.value = false
                  fetchAll(1);
                }
              }, 100);

              itemsData.value = result.data.data
              resultData.value = result

              to.value = result.data.data ? result.data.data.length : 0;

              if (result.data.config && Object.keys(result.data.config).length > 0) {
                const { config } = result.data;
                if (config.department) {
                  // dataDepartment.value = config.parentDepart
                  parentDepart.value = config.parentDepart
                }
              }
            }
          } else {
            itemsData.value = []
            showToast(result.message, { variant: 'danger' })
          }
        })
    }

    const refreshData = () => {
      currentPage.value = 1
      loadDateRange.value = '';
      searchQuery.value = '';
      localSearchQuery.value = '';
      start_date.value = '';
      end_date.value = '';
      article_type.value = '';
      department_id.value = '';
      department_unit.value = ''
      fetchAll();
    }
    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value
      fetchAll()
    }

    watch([searchQuery, article_type, department_id, start_date, end_date, bookDate], () => {
      //console.log('allowResetCurrentPage.value', allowResetCurrentPage.value);
      if (allowResetCurrentPage.value) {
        currentPage.value = 1
      }
      allowRefetchPaginate.value = true
      // console.log('loading.value', loading.value);
      if (!loading.value) {
        fetchAll();
        // fetchAllDepartment()
      }
    });

    watch([currentPage], (newPage) => {
      // console.log('watch currentpage', newPage);
      if (!loading.value) {
        fetchAll();
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    });

    onMounted(() => {
      // console.log('onmouted', route.value);
      let dataCache = window.localStorage.getItem('VOVAT-route-category')
      dataCache = dataCache ? JSON.parse(dataCache) : null
      // console.log('dataCache: ', dataCache);
      if (dataCache && dataCache.path === route.value.path) {
        // console.log('dataCache.path === route.value.path', dataCache.path === route.value.path);
        currentSlug.value = dataCache.params.slug
        currentPage.value = dataCache.query.currentPage
        searchQuery.value = dataCache.query.searchQuery
        localSearchQuery.value = dataCache.query.searchQuery
        article_type.value = dataCache.query.article_type
        department_id.value = dataCache.query.department_id
        loadDateRange.value = dataCache.query.loadDateRange
        bookDate.value = dataCache.query.bookDate
        setTimeout(() => {
          allowResetCurrentPage.value = true
          // console.log('reset allowResetCurrentPage', allowResetCurrentPage.value);
        }, 0);
        loading.value = false
        fetchAll()
      } else {
        currentSlug.value = route.value.params.slug
        fetchAll()
      }
      // console.log('currentSlug.value', currentSlug.value);
      window.addEventListener('scroll', onWindowScroll)
    });

    onBeforeUnmount(() => {
      // console.log('onbeforeunmoundted', route.value);
      const dataCache = {
        path: route.value.path,
        name: route.value.name,
        params: route.value.params,
        query: {
          currentPage: currentPage.value,
          searchQuery: searchQuery.value,
          article_type: article_type.value,
          department_id: department_id.value,
          loadDateRange: loadDateRange.value,
          bookDate: bookDate.value,
        },
      }
      // console.log('dataCache', dataCache);
      window.localStorage.setItem('VOVAT-route-category', JSON.stringify(dataCache))

      window.removeEventListener('scroll', onWindowScroll);
    });

    return {
      articleId,
      openPreviewModal,
      showPreview,
      onPreviewHidden,
      tableColumns,
      dataMeta,
      itemsData,
      currentPage,
      perPage,
      loading,
      article_type,
      dataDepartment,
      refListTable,
      localSearchQuery,
      dataArticleType,
      refreshData,
      total,
      category_id,
      department_id,
      parentDepart,
      start_date,
      end_date,
      loadDateRange,
      updateSearchQuery,
      dataCategory,
      currentSlug,
      category,
      showMode,
      classShowMode,
      resultData,
      bookDate,
      Imgsize,
      dataPhongBan,
      department_unit,
      shortcuts,
      searchQuery,
      switchMode,
      capFirst,
      compactShowPart,
      extraShowPart,
      lengthPart,
      renderClassTitleView,
      onViewArticle,
      onReadArticle,
    }
  },
  methods: {

  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
